module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-01-40074c09.svg";